<template>
  <div class="repayment-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <div class="header-left">
          <div class="brand-accent-bar"></div>
          <h1 class="header-title">My Loan</h1>
          <p class="header-subtitle">Instant repayment & loan status</p>
        </div>
        <button
          class="header-button"
          @click="goRolloverPae()"
          v-if="repayment.dueDate != null && repayment.remainAmount != null"
        >
          Extension Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        v-if="repayment.dueDate != null"
      >
        <div
          class="status-indicator"
          :class="repayment.remainingDays > 0 ? 'on-time' : 'overdue'"
        >
          <span class="days-count">{{
            Math.abs(repayment.remainingDays)
          }}</span>
          <span class="days-label">{{
            repayment.remainingDays > 0 ? "Remaining days" : "Days overdue"
          }}</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value amount-gold"
              >${{ formatAmount(repayment.remainAmount, 0, ".", ".") }}</span
            >
            <span class="detail-label">Amount to pay</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(repayment.dueDate)
            }}</span>
            <span class="detail-label">Due date</span>
          </div>
        </div>
      </div>

      <!-- Loan closed message -->
      <div
        class="card status-card loan-closed-card"
        style="text-align: center;"
        v-if="loanClosed"
      >
        <div class="loan-closed-message">
          <p class="closed-title">
            Loan successfully closed
          </p>
          <p class="closed-desc">
            You can apply for a higher amount next time.
          </p>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 贷款详情卡片 -->
      <div
        class="card info-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="info-row">
          <span class="row-label">Móvil</span>
          <span class="row-value"
            >***
            {{ repayment.phone ? repayment.phone.substr(5, repayment.phone.length - 1) : '' }}</span
          >
        </div>

        <div class="info-row">
          <span class="row-label">Status</span>
          <span class="status-badge">Prepare to pay</span>
        </div>

        <div class="info-row">
          <span class="row-label">Account holder:</span>
          <span class="row-value">{{ repayment.titular }}</span>
        </div>

        <!-- Pay now button -->
        <div class="btn-container">
          <button
            class="primary-btn"
            @click="copyCLABE"
          >
            Pay now →
          </button>
        </div>
      </div>

      <!-- 无到期日时的卡片 -->
      <div
        class="card advice-card"
        v-if="repayment.dueDate == null && repayment.remainAmount != null"
      >
        <p class="advice-text">
          Maintain and take care of your credit, it would avoid an extra charge
          for the delay. We suggest making the payment with the following
          accounts:
        </p>
        <div class="info-row">
          <span class="row-label">Account holder:</span>
          <span class="row-value">{{ repayment.titular }}</span>
        </div>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div style="display: flex; align-items: flex-start;">
          <span class="warning-icon">🛡️</span>
          <div>
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="!(repayment.dueDate == null && repayment.remainAmount == null)"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "Repayment",
  data() {
    return {
      repayment: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      clabe: null,
      instance: null,
      showBankSelection: false,
      expandedCategories: {},
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
      loanClosed: false,
    };
  },
  mounted() {
    document.title = "My Loan";
  },
  created() {
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },

    penaltyWaiver() {
      if (this.repayment.penaltyUrl) {
        window.open(this.repayment.penaltyUrl, "_blank");
        let keyStr = this.getParamQueryString(window.location.href, "key");
        this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "open_penalty_waiver",
          },
          true,
        );
      }
    },
    formatAmount(
      amount,
      decimals = 2,
      decimalSeparator = ".",
      thousandSeparator = ",",
    ) {
      amount = Number(amount);
      if (isNaN(amount)) {
        return "";
      }
      const factor = Math.pow(10, decimals);
      amount = Math.round(amount * factor) / factor;
      let amountStr = amount.toFixed(decimals);
      const [integerPart, decimalPart] = amountStr.split(".");
      const integerPartWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandSeparator,
      );
      return (
        integerPartWithSeparator +
        (decimalPart ? decimalSeparator + decimalPart : "")
      );
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getRepaymentInfo({ key: keyStr }, true);
      this.repayment = res;

      if (res.dueDate == null && res.remainAmount == null) {
        this.loanClosed = true;
      }

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    goRolloverPae() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/rollover", query: { key: keyStr } });
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
          },
          false,
        );
        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }
        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;
      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.repayment.repaymentBankName = bankName;
      this.showBankSelection = false;
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: false,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        if (response && response.loanClosed) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        } else if (
          response &&
          response.dueDate == null &&
          response.remainAmount == null
        ) {
          this.loanClosed = true;
          if (this.$toast) {
            this.$toast.success(
              "Loan successfully closed. You can apply for a higher amount next time.",
            );
          }
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器：暖白米色轻奢背景 */
.repayment-container {
  min-height: 100vh;
  background-color: transparent;
  color: #1F2937;
  padding-bottom: 40px;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: transparent;
}

/* 头部样式：科技蓝渐变 Banner + 白字 + 底部大圆角 */
.header {
  background: linear-gradient(135deg, #3B68FF 0%, #2E5BFF 50%, #1F48E0 100%);
  padding: 24px 20px 48px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;
  box-shadow: 0 12px 30px rgba(46, 91, 255, 0.25);
}

.brand-accent-bar {
  width: 34px;
  height: 4px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 2px;
  margin-bottom: 8px;
}

.header-left {
  display: flex;
  flex-direction: column;
}

.header-title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0 0 4px 0;
  color: #FFFFFF;
  text-shadow: 0 2px 8px rgba(31, 72, 224, 0.25);
}

.header-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 500;
  line-height: 1.3;
}

/* 右上角药丸胶囊按钮：半透明白底 + 纯白文字 */
.header-button {
  background-color: rgba(255, 255, 255, 0.22);
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 12px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.header-button:hover {
  background-color: rgba(255, 255, 255, 0.32);
  border-color: rgba(255, 255, 255, 0.7);
}

.header-button:active {
  transform: scale(0.96);
}

/* 卡片通用样式：纯白面板 + 柔和现代冷调阴影 + 大圆角 */
.card {
  background: #FFFFFF;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 10px 30px rgba(46, 91, 255, 0.06), 0 2px 10px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(226, 232, 240, 0.9);
  margin: 0 16px 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

/* 状态卡片 (悬浮Header下方) */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 22px;
  background: #FFFFFF;
  margin-top: -32px;
  position: relative;
  z-index: 10;
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 14px 36px rgba(46, 91, 255, 0.12), 0 4px 12px rgba(0, 0, 0, 0.04);
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid rgba(226, 232, 240, 0.85);
  min-width: 100px;
}

.days-count {
  font-size: 34px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.5px;
}

.status-indicator.on-time .days-count {
  color: #059669;
}

.status-indicator.overdue .days-count {
  color: #DC2626;
}

.days-label {
  font-size: 11px;
  margin-top: 6px;
  color: #6B7280;
  font-weight: 600;
}

.status-details {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 19px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 2px;
  margin-top: 2px;
}

.detail-value.amount-gold {
  color: #2E5BFF;
}

.detail-label {
  font-size: 11px;
  color: #6B7280;
  font-weight: 600;
}

/* 贷款已结清卡片 */
.loan-closed-card {
  text-align: center;
  justify-content: center;
}

.loan-closed-message {
  padding: 6px 0;
}

.closed-title {
  font-size: 17px;
  font-weight: 800;
  margin: 0 0 4px 0;
  color: #2E5BFF;
}

.closed-desc {
  font-size: 13px;
  color: #6B7280;
  margin: 0;
}

/* 内容区域 */
.content {
  padding-bottom: 100px;
  max-width: 600px;
  margin: 0 auto;
}

/* 贷款详情卡片 */
.info-card {
  padding: 22px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background-color: #F8FAFC;
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(226, 232, 240, 0.85);
  font-size: 14px;
}

.row-label {
  color: #6B7280;
  font-weight: 600;
}

.row-value {
  font-weight: 800;
  color: #111827;
}

/* 状态标签：科技蓝胶囊 */
.status-badge {
  background-color: rgba(46, 91, 255, 0.10);
  color: #2E5BFF;
  border: 1px solid rgba(46, 91, 255, 0.25);
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 700;
}

.btn-container {
  margin-top: 20px;
  text-align: center;
}

/* 建议卡片 */
.advice-card {
  padding: 22px;
  margin: 0 16px 16px;
}

.advice-text {
  margin-bottom: 14px;
  line-height: 1.5;
  color: #4B5563;
  font-size: 13px;
}

/* 安全提醒卡片：柔和浅科技蓝卡片 */
.warning-card {
  padding: 16px 18px;
  margin: 16px 16px 16px;
  background-color: #EEF2FF !important;
  border: 1px solid rgba(46, 91, 255, 0.22) !important;
  border-radius: 18px !important;
}

.warning-icon {
  font-size: 20px;
  margin-right: 12px;
}

.warning-title {
  font-weight: 800;
  margin: 0 0 4px 0;
  color: #2E5BFF;
  font-size: 14px;
}

.warning-desc {
  margin: 0 0 3px 0;
  font-size: 12px;
  color: #4B5563;
  line-height: 1.45;
}

/* UTR 输入卡片 */
.utr-card {
  padding: 22px;
  margin: 0 16px 20px;
}

.utr-label {
  display: block;
  font-size: 16px;
  font-weight: 800;
  margin-bottom: 4px;
  color: #111827;
}

.utr-desc {
  font-size: 12px;
  color: #6B7280;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: #F8FAFC;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #111827;
  font-weight: 700;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #2E5BFF;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(46, 91, 255, 0.15);
}

.utr-input::placeholder {
  color: #9CA3AF;
  font-weight: normal;
}

/* 粘贴按钮：科技蓝小胶囊 */
.paste-btn {
  background-color: rgba(46, 91, 255, 0.10);
  border: 1px solid rgba(46, 91, 255, 0.25);
  border-radius: 14px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 700;
  color: #2E5BFF;
  cursor: pointer;
  transition: all 0.2s;
}

.paste-btn:hover {
  background-color: rgba(46, 91, 255, 0.18);
}

.paste-btn:active {
  transform: scale(0.96);
}

.error-message {
  color: #DC2626;
  font-size: 12px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #059669;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

/* 主行动按钮：科技蓝渐变圆角大按钮 */
.primary-btn,
.submit-utr-btn {
  position: relative;
  width: 100%;
  background: linear-gradient(135deg, #3B68FF 0%, #2E5BFF 50%, #1F48E0 100%);
  color: #FFFFFF;
  border: none;
  border-radius: 16px;
  padding: 15px;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(46, 91, 255, 0.32), 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #537CFF 0%, #3D67FF 50%, #254FE6 100%);
  box-shadow: 0 10px 28px rgba(46, 91, 255, 0.42);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.94;
}

.submit-utr-btn:disabled {
  background: #E2E8F0;
  color: #94A3B8;
  box-shadow: none;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .status-card {
    flex-direction: row;
  }
}
</style>
